import axios from 'axios';

axios.defaults.baseURL = import.meta.env.VITE_BASE_API_URL;
// Send/accept the API-domain tracking cookie (apply_uid) so the backend can
// link the application to later interview requests (see keyslabor PR #349).
axios.defaults.withCredentials = true;

export * from 'axios';

export default axios;
